import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { Grid } from '@ali/aps-dev';
import { observer, inject } from 'mobx-react';
import CheckItem from './CheckItem';
import './screen.scss';

const Row = Grid.Row;

@inject('checkListStore', 'resultListStore')
@observer
class CheckListMobile extends Component {
  constructor(props) {
    super(props);
    this.checkListStore = this.props.checkListStore;
    this.handlerShowCheckList = this.checkListStore.handlerShowCheckList.bind(this.checkListStore);
    this.labelTags = {
      suffixs: '后缀',
      types: '分类',
      length: '长度',
      numbers: '价格'
    };
    this.labelObj = {
      suffixs: [
        { text: '不限', value: ' ' },
        { text: '.xin', value: 'xin' },
        { text: '.top', value: 'top' },
        { text: '.vip', value: 'vip' },
        { text: '.wang', value: 'wang' },
        { text: '.club', value: 'club' },
        { text: '.ltd', value: 'ltd' },
        { text: '.group', value: 'group' },
        { text: '.我爱你', value: '我爱你' },
        { text: '.ren', value: 'ren' },
        { text: '.link', value: 'link' },
        { text: '.kim', value: 'kim' },
        { text: '.shop', value: 'shop' },
        { text: '.xyz', value: 'xyz' }
      ],
      types: [
        { text: '不限', value: ' ' },
        { text: '数字', value: 11 },
        { text: '字母', value: 12 },
        { text: '单词', value: 16 },
        { text: '拼音', value: 15 }
      ],
      length: [
        { text: '不限', value: ' ' },
        { text: '1个', value: 1 },
        { text: '2个', value: 2 },
        { text: '3个', value: 3 },
        { text: '4个', value: 4 }
      ],
      numbers: [
        { text: '不限', value: ' ' },
        { text: '0-200', value: '0,200' },
        { text: '200-1000', value: '200,1000' },
        { text: '1000-5000', value: '1000,5000' },
        { text: '5000-1000', value: '5000,10000' }
      ]
    };
  }
  handlerChangeCheck(key, event) {
    this.props.checkListStore.handlerChangeCheck(key, event);
  }
  render() {
    let rowsListMobile = [];
    let index = 0;
    for (let key in this.labelObj) {
      rowsListMobile.push(
        <CheckItem
          key={index++}
          labelTag={this.labelTags[key]}
          items={this.labelObj[key]}
          handlerChangeCheck={this.handlerChangeCheck.bind(this, key)}
          label={this.checkListStore.labels[key]}
          isPc={false} />
      );
    }
    return (
      <div className="check-list-mobile screen-title">
        <p className="title-wraper">
          <span className="title-back"
            onClick={this.handlerShowCheckList}>返回</span>
          <span className="title-center">筛选</span>
          <span className="title-save"
            onClick={this.handlerShowCheckList}>保存</span>
        </p>
        <Row className="check-list buttons-mobile">
          {rowsListMobile}
        </Row>
      </div>
    );
  }
}
export default CheckListMobile;


// WEBPACK FOOTER //
// ./src/components/Screen/CheckListMobile.js